module.exports = __webpack_public_path__ + "static/media/PrincessUnlimitedJacket.1523d2a7.jpg";